/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sort_NameInputs */



/**
* | output |
* | --- |
* | "Name" |
*
* @param {Team_Sort_NameInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_sort_name = /** @type {((inputs?: Team_Sort_NameInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sort_NameInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naam")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom")
	return /** @type {LocalizedString} */ ("Name")
});